const FIRESTORE_ERROR_EXPLANATIONS = {
    'permission-denied':
        'Firestore-reglerne afviste skrivningen. Kontrollér at firestore.rules er udrullet '
        + 'og tillader de felter, siden gemmer.',
    unauthenticated: 'Du er ikke logget ind længere. Genindlæs siden og log ind igen.',
    unavailable: 'Der er ingen forbindelse til Firestore. Kontrollér din internetforbindelse.',
    'invalid-argument':
        'Firestore afviste indholdet. Dokumentet kan være for stort, eller et felt kan have '
        + 'en ugyldig værdi.',
    'not-found': 'Dokumentet findes ikke længere.',
    'deadline-exceeded': 'Skrivningen tog for lang tid. Prøv igen.',
};

/**
 * Builds a user-facing description of a Firebase error, keeping the raw code visible so a
 * reported message can be matched against the browser console without extra debugging.
 */
export function describeFirestoreError(error) {
    const code = typeof error?.code === 'string' ? error.code : '';
    const shortCode = code.startsWith('firestore/') ? code.slice('firestore/'.length) : code;
    const explanation = FIRESTORE_ERROR_EXPLANATIONS[shortCode];
    const message = typeof error?.message === 'string' ? error.message.trim() : '';

    if (explanation) return `${explanation} (${shortCode})`;
    if (code && message) return `${message} (${code})`;
    if (message) return message;
    if (code) return code;
    return 'Ukendt fejl. Se browserens konsol for detaljer.';
}
